import React from "react";
import { Input, TextArea, DateInput } from "../../../../../../common/Input";
import { EmployeePickerField } from "../../../../../../common/selectComponents/EmployeePicker";
import VesselPickerField from "../../../../../../common/selectComponents/VesselPicker";
import SectionBadge from "../../ui/SectionBadge";

const AssignmentDetailsTab = ({ form, set, editable, errors }) => {
  const isAllowWithBenefitFeature = false;
  return (
    <div className="space-y-6 pt-2">
      <div className="bg-gray-50 p-6 rounded-xl border border-gray-200">
        <SectionBadge label="Assignment Details" editable={editable} />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-10 gap-y-4 mb-3">
          <Input
            label="Transaction Code:"
            value={form.transactionCode || ""}
            isDisabled={true}
            placeholder="-- Auto Generated --"
          />
          <DateInput
            label="Effective From:"
            value={form.effectiveFrom}
            onChange={e => set('effectiveFrom', e.target.value)}
            disabled={!editable}
            isRequired={true}
            error={!!errors.effectiveFrom}
            errorMessage={errors.effectiveFrom}
          />
          <EmployeePickerField
            label="TO (Recipient):"
            employeePersonalInformationId={form.recipientEmployeePersonalInformationId}
            displayValue={form.recipientData?.fullName || ""}
            onSelect={(emp) => { set('recipientEmployeePersonalInformationId', emp.id); set('recipientData', { fullName: emp.fullName }); }}
            onClear={() => { set('recipientEmployeePersonalInformationId', ""); set('recipientData', null); }}
            viewMode={!editable}
            allowClear={true}
            isRequired={true}
            error={!!errors.recipientEmployeePersonalInformationId}
            errorMessage={errors.recipientEmployeePersonalInformationId}
          />
          {!form?.isOnLeave && (
            <VesselPickerField
              label="Destination Vessel:"
              vesselId={form.destinationVesselId}
              displayValue={form.destinationVesselCode || "--Select--"}
              onSelect={(v) => { set('destinationVesselId', v.id); set('destinationVesselCode', v.code); }}
              onClear={() => { set('destinationVesselId', ""); set('destinationVesselCode', ""); }}
              viewMode={!editable}
              allowClear={true}
              isRequired={!form?.isOnLeave}
              error={!!errors.destinationVesselId && !form?.isOnLeave}
              errorMessage={!form?.isOnLeave ? errors.destinationVesselId : null}
            />
          )}
        </div>
        <TextArea
          label="Remarks:"
          value={form.remarks || ""}
          onChange={e => set('remarks', e.target.value)}
          placeholder="Enter any additional instructions or remarks..."
          disabled={!editable}
          rows={2}
          isRequired={true}
          error={!!errors.remarks}
          errorMessage={errors.remarks}
        />

        <div className="flex flex-col md:flex-row gap-6">
          <div className="pt-4 border-t border-gray-200">
            <label className={`flex items-center gap-3 ${editable ? "cursor-pointer" : "cursor-not-allowed opacity-60"}`}>
              <input type="checkbox" checked={!!form.isActive} onChange={e => set('isActive', e.target.checked)} disabled={!editable} className="w-4 h-4 accent-blue-600" />
              <span className="text-sm font-medium text-gray-700">Is Active</span>
            </label>
          </div>

          <div className="pt-4 border-t border-gray-200">
            <label className={`flex items-center gap-3 ${editable ? "cursor-pointer" : "cursor-not-allowed opacity-60"}`}>
              <input type="checkbox" checked={!!form.isOnLeave} onChange={e => set('isOnLeave', e.target.checked)} disabled={!editable} className="w-4 h-4 accent-blue-600" />
              <span className="text-sm font-medium text-gray-700">Is On Leave</span>
            </label>
          </div>

          <div className="pt-4 border-t border-gray-200">
            <label className={`flex items-center gap-3 ${editable ? "cursor-pointer" : "cursor-not-allowed opacity-60"}`}>
              <input type="checkbox" checked={!!form.isWithTime} onChange={e => set('isWithTime', e.target.checked)} disabled={!editable} className="w-4 h-4 accent-blue-600" />
              <span className="text-sm font-medium text-gray-700">w/time</span>
            </label>
          </div>
          {isAllowWithBenefitFeature && (
            <div className="pt-4 border-t border-gray-200">
              <label className={`flex items-center gap-3 ${editable ? "cursor-pointer" : "cursor-not-allowed opacity-60"}`}>
                <input type="checkbox" checked={!!form.isWithBenefits} onChange={e => set('isWithBenefits', e.target.checked)} disabled={!editable} className="w-4 h-4 accent-blue-600" />
                <span className="text-sm font-medium text-gray-700">w/benefits</span>
              </label>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default AssignmentDetailsTab;